export {
    TRADE_WELCOME_PROMO_CODE,
    TRADE_SHIP_PROMO_CODE,
    RISK_FREE_PROMO_CODE,
} from '../src/notificationQueue/globalNotifications/tradePromos/constants';
